import { Step } from '../../shared/components/Stepper/Stepper.types'

export const CREATE_EXTERNAL_FLIGHT_BOOKING_PAYMENT_INTENT_STORAGE_KEY = 'CREATE_EXTERNAL_FLIGHT_BOOKING_PAYMENT_INTENT'
export const ACCOUNT_SESSION_STORAGE_KEY = 'ACCOUNT_SESSION'
export const FLIGHT_ITINERARY_STORAGE_KEY = 'FLIGHT_ITINERARY'
export const DELIVERY_DETAILS_STORAGE_KEY = 'DELIVERY_DETAILS'

export const defaultSteps: Step[] = [
  { label: 'Review Trip Details' },
  { label: 'Delivery Details' },
  { label: 'Payout Details' },
  { label: 'Payment Details' },
  { label: 'Confirmation Complete' }
]

export const splitDeliverySteps: Step[] = [
  { label: 'Review Trip Details' },
  { label: 'Stay Address' },
  { label: 'Dropoff Location' },
  { label: 'Payout Details' },
  { label: 'Payment Details' },
  { label: 'Confirmation Complete' }
]

export const defaultStepDetails = {
  reviewTripDetails: {
    headerTitle: defaultSteps[0].label,
    headerSubtitle: 'Review the details of your trip.',
    step: defaultSteps[0],
    index: 0
  },
  deliveryDetails: {
    headerTitle: defaultSteps[1].label,
    headerSubtitle:
      'Provide delivery address. Items will be delivered to this address x days before your flight to your destination.',
    step: defaultSteps[1],
    index: 1
  },
  setupStripeConnectAccount: {
    headerTitle: defaultSteps[2].label,
    headerSubtitle: 'Set up a payout that can be used to pay for your trips.',
    step: defaultSteps[2],
    index: 2
  },
  setupPaymentDetails: {
    headerTitle: defaultSteps[3].label,
    headerSubtitle: 'Set up a card that can be used to pay for your trips.',
    step: defaultSteps[3],
    index: 3
  },
  confirmationComplete: {
    headerTitle: defaultSteps[4].label,
    headerSubtitle: 'Your booking details have been confirmed.',
    step: defaultSteps[4],
    index: 4
  }
}

export const splitDeliveryStepDetails = {
  reviewTripDetails: {
    headerTitle: splitDeliverySteps[0].label,
    headerSubtitle: 'Review the details of your trip.',
    step: splitDeliverySteps[0],
    index: 0
  },
  stayAddress: {
    headerTitle: splitDeliverySteps[1].label,
    headerSubtitle: 'Provide your stay address using the fields below.',
    step: splitDeliverySteps[1],
    index: 1
  },
  dropoffLocation: {
    headerTitle: splitDeliverySteps[2].label,
    headerSubtitle: 'Choose a USPS drop-off location for your packages.',
    step: splitDeliverySteps[2],
    index: 2
  },
  setupStripeConnectAccount: {
    headerTitle: splitDeliverySteps[3].label,
    headerSubtitle: 'Set up a payout that can be used to pay for your trips.',
    step: splitDeliverySteps[3],
    index: 3
  },
  setupPaymentDetails: {
    headerTitle: splitDeliverySteps[4].label,
    headerSubtitle: 'Set up a card that can be used to pay for your trips.',
    step: splitDeliverySteps[4],
    index: 4
  },
  confirmationComplete: {
    headerTitle: splitDeliverySteps[5].label,
    headerSubtitle: 'Your booking details have been confirmed.',
    step: splitDeliverySteps[5],
    index: 5
  }
}
